export default "__VITE_ASSET__B9tbMSi1__"